import React, { useEffect, useState } from "react";
import "../../assets/css/tables.css";
import Swal from "sweetalert2";
import deletes from "../../assets/images/tablesImg/delete.png";
import edit from "../../assets/images/tablesImg/edit.png";
import testBluePng from "../../assets/images/notes/notes.svg";
import more_vert from "../../assets/images/home/more_vert.png";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import Repository from "../../configs/axios/repository";
import { handleGetFlashcard } from "../../redux/layout";
import { handleGetTikets } from "../../redux/layout";
import {
    UncontrolledDropdown,
    DropdownMenu,
    DropdownToggle,
    DropdownItem,
} from "reactstrap";
import { useSelector } from "react-redux";
import { openFlashcard } from "../globalFunctions/openFlashcard";
import { openTest } from "../globalFunctions/openTest";
const TryforfreeNoteTable = ({
    notes,
    refreshTable,
    loadingData,
    course_id,
    canDoIt,
    courseName,
    fromCourse,
}) => {
    const [showCources, setShowCources] = useState(true);
    const isInvateValue = useSelector((state) => state.layout.isInvate);
    const role = useSelector((state) => state.layout.role);

    const currentPathname = window.location.pathname;
    const history = useHistory();
    const dispatch = useDispatch();

    const getNoteById = async (file, type) => {
        let note_id = {
            note_id: file.note_id,
        };

        let notes = file.summary ? file.summary : file.notes;
        let noteData = {
            title: file.title,
            description: file.description,
            summary: file.summary,
        };
        if (type == "flashcard") {
            let array = JSON.parse(file.flashcard[0].flashcard_content);
            let testType = file.flashcard_type;
            let note_id = file.note_id.note_id;
            let flashcard_id = file.flashcard[0].flashcard_id;
            let flashcard_name = file.flashcard[0].flashcard_name;
            let isData = true;

            history.push({
                pathname: "/flashcardTest",
                state: {
                    array,
                    testType,
                    note_id,
                    isData,
                    flashcard_id,
                    flashcard_name,
                    noteData,
                    notes,
                },
            });
        }

        if (
            (type == "choice" || type == "written") &&
            file.test_note.length > 0
        ) {
            let filtredTests = file.test_note.filter(
                (test) => test.test_type === type
            );

            let testData = {
                test_id: filtredTests[0]?.test_id,
                test_name: filtredTests[0]?.test_name,
                test_content: JSON.parse(filtredTests[0]?.test_content),
                test_prompt: filtredTests[0].test_prompt,
                icon: filtredTests[0]?.icon,
                note_id: {
                    note_id: file.note_id,
                },
                note: notes,
                no_of_questions: filtredTests[0].no_of_questions,
                test_type: type,
            };

            let array = JSON.parse(filtredTests[0]?.test_content);
            let note_id = file.note_id;
            let testType = type;
            let isData = true;

            history.push({
                pathname: "/freeTest",
                state: {
                    array,
                    testType,
                    note_id,
                    isData,
                    noteData,
                    canDoIt,
                    fromCourse,
                    testData,
                },
            });
        }
    };

    useEffect(() => {
        setShowCources(isInvateValue);
    }, [isInvateValue]);

    const thumbs = notes?.map((file, i) => {
        return (
            <div key={i} className="notesContent mt-4">
                <div
                    className="parentCoursesDiv "
                    onClick={(e) => {
                        history.push({
                            pathname: "/tryforfree",
                        });
                    }}
                >
                    <div className="clidrenDivCompakt">
                        <div>
                            <img src={testBluePng} alt="testPng" />
                        </div>
                        <div>
                            <div className="mt-3">
                                <span>{file.title}</span>
                                <p>{file.description}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className=" notesFildsParrent">
                    <div className="notesFilds">
                        <button
                            className="flashButton"
                            onClick={() => {
                                getNoteById(file, "flashcard");
                            }}
                        >
                            Flashcards
                        </button>

                        <button
                            className="flashButton"
                            onClick={() => {
                                getNoteById(file, "choice");
                            }}
                        >
                            Multiple Choice
                        </button>
                        {/* )} */}

                        <button
                            className="flashButton"
                            onClick={() => {
                                getNoteById(file, "written");
                            }}
                        >
                            Written
                        </button>
                    </div>
                </div>
            </div>
        );
    });

    return <div className="divTable"> {thumbs} </div>;
};

export default TryforfreeNoteTable;
